import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Modal } from '@components/Modal';
import { buildDefaultMasterScriptData } from '../utils/stepDefaults';

type Props = {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string, scriptData: string) => void;
  isPending: boolean;
};

const CreateScriptDialog: React.FC<Props> = ({
  open,
  onClose,
  onCreate,
  isPending
}) => {
  const [name, setName] = useState('');

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreate(trimmed, buildDefaultMasterScriptData());
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Modal.Header title="Create Script" onClose={handleClose} />
      <Modal.Content>
        <TextField
          label="Script Name"
          value={name}
          onChange={e => setName(e.target.value)}
          autoFocus
          fullWidth
          size="small"
        />
      </Modal.Content>
      <Modal.Footer
        primaryButton={{
          text: 'Create',
          onClick: handleSubmit,
          disabled: !name.trim() || isPending
        }}
        secondaryButton={{
          text: 'Cancel',
          onClick: handleClose,
          variant: 'text' as const
        }}
      />
    </Modal>
  );
};

export default CreateScriptDialog;
